import stydent_practice from './stydent-practice';
import controlles from './controlles';
import calendar from './calendar';
import gradebook from './gradebook';
import student from './student';

export default {
    ...stydent_practice,
    ...controlles,
    ...calendar,
    ...gradebook,
    ...student,
};
